export * from './src/automations-v1-automations-custom-trigger-custom-trigger.meta.js';
